import React from 'react'

const Receipt = props => {

    return (
    <div className='Receipt'>
        Receipt
    </div>
    )
}

export default Receipt